import styled from "styled-components";

export const WorkflowScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const HR = styled.div`
  border: 1px solid #cbd9e1;
  margin: 1rem 0;
`;
export const VR = styled.div`
  border-left: 1px solid #cbd9e1;
  margin: 0 1rem;
  width: 1px;
  height: 100%;
`;
export const BlueLabel = styled.div`
  color: #0a85c7;
  margin-right: 1rem;
  font-size: 1.25rem;
`;
export const InputLabel = styled.div`
  color: #355263;
  font-size: 1rem;
  font-weight: 600;
`;
export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 1rem;
`;
export const Label = styled.span`
  color: #02273c;
  font-size: 1rem;
  font-weight: 300;
`;
export const Value = styled.span<{ isNA?: boolean }>`
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => (props.isNA ? "#75909F" : "#355263")};
`;
export const LabelContainer = styled.div`
  display: grid;
  justify-content: space-between;
`;
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;
